export class ScrollUtil {
	static scrollToBottom(className: string = '.custom-scroll-container'): void {
		const container = document.querySelector(className)
		container?.scrollTo({ top: container.scrollHeight, behavior: 'smooth' })
	}

	static scrollIntoViewToClassName(className: string): void {
		const container = document.querySelector(`.${className}`)
		setTimeout(() => {
			container?.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}, 400)
	}
}
